export default __webpack_public_path__ + "static/media/apple-pay.66c6f129.png";